@if (user && (Roles.Codalt | hasRole)) {
    <div class="mb-2 font-weight-bold"><h2>Inloggegevens</h2></div>
    <div class="login-info-grid mb-3">
        @if (user.total_login_attempts) {
            <div class="d-flex flex-column h-100">
                <h4 class="mb-1"><i class="fas fa-exclamation-triangle me-2"></i>Mislukte inlogpogingen</h4>
                <p class="mb-3 flex-grow-1">
                    Deze gebruiker heeft <strong>{{ user.total_login_attempts }}</strong> mislukte inlogpoging(en) sinds
                    de laatste succesvolle inlog.
                    @if (user.last_login_attempt) {
                        Laatste mislukte poging op
                        <strong>{{ user.last_login_attempt | date: 'EEE d MMM yyyy HH:mm' }} uur.</strong>
                    }
                    @if (user.last_login_at) {
                        Laatst succesvol ingelogd op
                        <strong>{{ user.last_login_at | date: 'EEE d MMM yyyy HH:mm' }} uur.</strong>
                    }
                </p>
                <button mat-stroked-button type="button" (click)="resetLoginAttempts()">Inlogblokkade opheffen</button>
            </div>
        }

        @if (pincodeLoginAllowed) {
            <div class="d-flex flex-column h-100">
                <h4 class="mb-1">Inlogcode</h4>
                <p class="mb-3 flex-grow-1">
                    Deze gebruiker logt in met een code. Maak hier een nieuwe code aan om door te geven: die is 15
                    minuten geldig, eenmalig te gebruiken, en maakt een eerder aangemaakte code ongeldig.
                </p>
                @if (newPin) {
                    <button mat-stroked-button type="button" (click)="copyToClipboard(newPin, 'pin')">
                        @if (copied === 'pin') {
                            <i class="fas fa-check me-2"></i>
                        } @else {
                            <i class="far fa-copy me-2"></i>
                        }
                        Inlogcode: {{ newPin }}
                    </button>
                } @else {
                    <button mat-stroked-button type="button" [disabled]="generatingPin" (click)="getNewPin()">
                        Nieuwe inlogcode tonen
                    </button>
                }
                @if (pinError) {
                    <p class="mt-2 mb-0 text-danger">{{ pinError }}</p>
                }
            </div>
        }

        @if (passwordLoginAllowed) {
            <div class="d-flex flex-column h-100">
                <h4 class="mb-1">Wachtwoord</h4>
                <p class="mb-3 flex-grow-1">
                    Deze gebruiker logt in met een wachtwoord. Maak hier een nieuw wachtwoord aan om door te geven. Het
                    vorige wachtwoord werkt daarna niet meer.
                </p>
                @if (newPassword) {
                    <button mat-stroked-button type="button" (click)="copyToClipboard(newPassword, 'password')">
                        @if (copied === 'password') {
                            <i class="fas fa-check me-2"></i>
                        } @else {
                            <i class="far fa-copy me-2"></i>
                        }
                        Wachtwoord: {{ newPassword }}
                    </button>
                } @else {
                    <button mat-stroked-button type="button" [disabled]="generatingPassword" (click)="getNewPassword()">
                        Nieuw wachtwoord tonen
                    </button>
                }
                @if (passwordError) {
                    <p class="mt-2 mb-0 text-danger">{{ passwordError }}</p>
                }
            </div>
        }

        @if (
            (Functionalities.UserTakeover | hasFunctionality) || (Functionalities.DirkUserTakeover | hasFunctionality)
        ) {
            <div class="d-flex flex-column h-100">
                <h4 class="mb-1">Beheer</h4>
                <div class="d-flex flex-column gap-2 flex-grow-1">
                    @if (Functionalities.UserTakeover | hasFunctionality) {
                        <button
                            [routerLink]="['/gebruikers/login-as', user.id]"
                            [disabled]="!!LocalStorage.parentUser"
                            [matTooltip]="LocalStorage.parentUser ? 'Niet mogelijk vanuit een overgenomen account' : ''"
                            mat-stroked-button
                            color="warn">
                            Inloggen als deze gebruiker
                        </button>
                    }

                    @if (environment.dirkAppUrl && (Functionalities.DirkUserTakeover | hasFunctionality)) {
                        <a
                            [routerLink]="LocalStorage.parentUser ? null : ['/gebruikers/login-as-dirk', user.id]"
                            [disabled]="!!LocalStorage.parentUser"
                            [matTooltip]="LocalStorage.parentUser ? 'Niet mogelijk vanuit een overgenomen account' : ''"
                            target="_blank"
                            rel="noopener noreferrer"
                            mat-stroked-button
                            color="warn">
                            Inloggen als deze gebruiker in Dirk
                        </a>
                    }
                </div>
            </div>
        }
    </div>
}
